import { render, staticRenderFns } from "./UpdateBroker.vue?vue&type=template&id=9563065e"
import script from "./UpdateBroker.vue?vue&type=script&lang=js"
export * from "./UpdateBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports